import { render, staticRenderFns } from "./moneyBack_list.vue?vue&type=template&id=1dddef94"
import script from "./moneyBack_list.vue?vue&type=script&lang=js"
export * from "./moneyBack_list.vue?vue&type=script&lang=js"
import style0 from "./moneyBack_list.vue?vue&type=style&index=0&id=1dddef94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports